import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";
import David from "../assets/profile/NewDave.jpeg";
import {
  FaGithub,
  FaLinkedin,
  FaDownload,
  FaSun,
  FaMoon,
  FaTwitter
} from "react-icons/fa";
import AboutMe from "../components/AboutMe";
import Skills from "../components/Skills";
import WorkExperience from "../components/YOE";
import Education from "../components/Education";

export default function Home() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    // Get theme from localStorage or default to dark
    const savedTheme = localStorage.getItem("theme") || "dark";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  return (
    <div className="home-page">
      <div className="home-container">
        {/* Left Column - Simple Intro */}
        <div className="home-left">
          <div className="hero-intro">
            <h1 className="hero-greeting-text">
              Hello! I'm{" "}
              <span className="hero-name-inline">David Olowomeye</span>.
            </h1>

            <p className="hero-description">
              Software Engineer | Applied AI & ML
            </p>

            {/* Navigation Links */}
            <div className="hero-nav-links">
              <a
                href="https://docs.google.com/document/d/1kEoqhQlhnuKRR_bnNJWoJY1VDSnzRQbGN2DehiW1ZOI/export?format=pdf&attachment=false"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                <span className="nav-number">00</span>
                <span className="nav-separator">—</span>
                <span className="nav-text">RESUME</span>
              </a>
              <Link to="/projects" className="nav-link">
                <span className="nav-number">01</span>
                <span className="nav-separator">—</span>
                <span className="nav-text">PROJECTS</span>
              </Link>
              <Link to="/blog" className="nav-link">
                <span className="nav-number">02</span>
                <span className="nav-separator">—</span>
                <span className="nav-text">BLOG</span>
              </Link>
              {/* <Link to="/youtube" className="nav-link">
                <span className="nav-number">03</span>
                <span className="nav-separator">—</span>
                <span className="nav-text">YOUTUBE</span>
              </Link> */}

              <Link to="/contact" className="nav-link">
                <span className="nav-number">03</span>
                <span className="nav-separator">—</span>
                <span className="nav-text">CONTACT</span>
              </Link>
            </div>

            {/* Profile Picture and Social Links */}
            <div className="hero-social">
              <div className="hero-profile">
                <img src={David} alt="David Olowomeye" />
              </div>
              <div className="hero-social-links">
                <a
                  href="https://github.com/greatdaveo"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <FaGithub />
                  <span>Github</span>
                  <span className="external-link">↗</span>
                </a>
                <a
                  href="https://www.linkedin.com/in/greatdaveo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                  <span>LinkedIn</span>
                  <span className="external-link">↗</span>
                </a>
                <a
                  href="https://twitter.com/greatdaveo"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                  <span>Twitter</span>
                  <span className="external-link">↗</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Name, Download, and Scrollable Content */}
        <div className="home-right">
          <div className="right-content">
            {/* Name and Download Button */}
            <div className="right-header">
              <h1 className="right-name">David Olowomeye</h1>
              <div className="header-actions">
                <button
                  className="theme-toggle"
                  onClick={toggleTheme}
                  aria-label={`Switch to ${
                    theme === "light" ? "dark" : "light"
                  } mode`}
                >
                  {theme === "light" ? <FaMoon /> : <FaSun />}
                </button>
                <a
                  href="https://docs.google.com/document/d/1kEoqhQlhnuKRR_bnNJWoJY1VDSnzRQbGN2DehiW1ZOI/export?format=pdf&attachment=false"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn"
                >
                  <FaDownload />
                  Download
                </a>
              </div>
            </div>

            <AboutMe />
            <Skills />
            <WorkExperience />
            <Education />
          </div>
        </div>
      </div>
    </div>
  );
}
